import {
    defaultVerificationMetricResource,
    useVerificationMetricActions,
} from '../../../../resource/resources/artifacts/verification_metric/verificationMetricResource';
import { ResourceType } from '../../../../resource/enumerations/ResourceType';
import { OpenModal } from '../../../../../../react-commons/utils/modals/openModal';
import {
    defaultProcessAreaVerificationMetricAssociationResource,
    useProcessAreaVerificationMetricAssociationActions,
} from '../../../../resource/resources/artifacts/process_area/processAreaVerificationMetricAssociationResource';
import { StackedCardsComponent } from '../../../reusable-components/StackedCardsComponent';
import { useDeleteResourceDialogFunction } from '../../../reusable-components/dialogs/UseDeleteResourceDialogFunction';
import React from 'react';
import {
    VerificationMetricEditDialog,
} from '../../project/reusable-elements/verification-metric/VerificationMetricEditDialog';
import { useNestedDialogFunction } from '../../../../../../react-commons/dialog-provider/UseNestedDialogFunction';

export const StackedVerificationMetricsView = ({isAdmin, processAreaId, versionId, link}: {
    isAdmin: boolean,
    processAreaId: string | undefined,
    versionId: string | undefined,
    link: string | undefined
}) => {

    const nestedDialog = useNestedDialogFunction();
    const deleteResourceDialogFunction = useDeleteResourceDialogFunction();

    const verificationMetricAssociationActions = useProcessAreaVerificationMetricAssociationActions()
    const verificationMetricActions = useVerificationMetricActions()
    const verificationMetricAssociationsQuery = verificationMetricAssociationActions.useGetAllResources(processAreaId)
    const verificationMetricsQuery = verificationMetricActions.useGetAllResources(versionId);

    const deleteVerificationMetricAssociation = verificationMetricAssociationActions.useDeleteResource();
    const addVerificationMetricAssociation = verificationMetricAssociationActions.useAddResource();
    const addVerificationMetric = verificationMetricActions.useAddResource();
    const addAssociation = () => OpenModal.SelectionOrCreateModal(
        "Select or Create a VerificationMetric",
        verificationMetricsQuery.data?.filter(verificationMetric =>
            !(verificationMetricAssociationsQuery.data
                ?.some(association => association.verificationMetric === verificationMetric.objectId)))
            .map(verificationMetric => ({label: verificationMetric.name, value: verificationMetric.objectId})) ?? [],
        true,
        null,
        async (value) => {
            if (value && processAreaId) {
                await addVerificationMetricAssociation.mutateAsync({
                    resource: {
                        ...defaultProcessAreaVerificationMetricAssociationResource,
                        verificationMetric: value
                    },
                    parentId: processAreaId
                })
            }
        },
        async (value, multiLineValue) => {
            if (value && processAreaId && versionId) {
                await addVerificationMetric.mutateAsync({
                        resource: {
                            ...defaultVerificationMetricResource,
                            name: value,
                            description: multiLineValue ?? ""
                        },
                        parentId: versionId
                    },
                    {
                        onSuccess: (result) => {
                            const verificationMetricObjectId = result?.content?.objectId
                            if (verificationMetricObjectId) {
                                addVerificationMetricAssociation.mutateAsync({
                                    resource: {
                                        ...defaultProcessAreaVerificationMetricAssociationResource,
                                        verificationMetric: verificationMetricObjectId
                                    },
                                    parentId: processAreaId
                                })
                            }
                        },
                    }
                )
            }
        },
        undefined,
        "Name",
        true,
        "Description",
        800
    )

    const onDelete = (id: string) => {
        deleteResourceDialogFunction.deleteResource(
            id, null, ResourceType.PROCESS_AREA_VERIFICATION_METRIC_ASSOCIATION, deleteVerificationMetricAssociation
        )
    }

    const onEdit = (id: string) => {
        const association = verificationMetricAssociationsQuery.data?.find(value => value.id === id)
        if (association) {
            nestedDialog.showNestedDialog(
                <VerificationMetricEditDialog
                    onClose={nestedDialog.closeNestedDialog}
                    objectId={association.verificationMetric}
                    versionedInId={versionId ?? ""}
                />
            );
        }
    }

    return (
        <StackedCardsComponent
            title={"Verification Metrics"}
            data={verificationMetricAssociationsQuery.data?.map(value => ({
                id: value.id,
                text: verificationMetricsQuery.data?.find(resource => resource.objectId === value.verificationMetric)?.name ?? "",
                description: verificationMetricsQuery.data?.find(resource => resource.objectId === value.verificationMetric)?.description ?? "",
                img: null
            })) ?? []}
            onAdd={isAdmin ? addAssociation : undefined}
            onDelete={isAdmin ? onDelete : undefined}
            onEdit={isAdmin ? onEdit : undefined}
            link={link}
            section={"verification-metrics"}
        />
    );
};